import { Props } from './PreviewContent';

export const chooseWhatToShow = (
  visual: Props['visual'],
  hasThumbnail: boolean,
  previewContentType: Props['previewContentType']
) => {
  let icon = undefined;
  if (previewContentType === 'video') {
    icon = 'video-camera';
  }
  if (previewContentType === 'pdf') {
    icon = 'file-pdf';
  }
  if (previewContentType === 'file') {
    icon = 'file';
  }
  if (previewContentType === 'link') {
    icon = 'link';
  }

  const imageOrVideo = ['video', 'image'].includes(previewContentType);

  const normal: {
    image: boolean;
    icon?: string;
    delete: boolean;
    loading: boolean;
    changeDeleteColor: boolean;
    error: boolean;
    pale: boolean;
    hoveredErrorMessage: boolean;
    rectangle: boolean;
    changeRectangleBgColor: boolean;
    link: boolean;
    twoLinedTitle: boolean;
  } = {
    image: hasThumbnail && previewContentType !== 'video', // this can be changed if we stat to receive video thumbnails
    icon: hasThumbnail ? undefined : icon,
    delete: false,
    loading: false,
    changeDeleteColor: false,
    error: false,
    pale: previewContentType === 'video' ? true : false,
    hoveredErrorMessage: false,
    rectangle: !imageOrVideo,
    changeRectangleBgColor: false,
    link: previewContentType === 'link',
    twoLinedTitle: previewContentType === 'link' ? false : true,
  };

  switch (visual) {
    case 'normal':
      return normal;
    case 'loading':
      return {
        ...normal,
        icon: undefined,
        loading: true,
        pale: true,
        changeRectangleBgColor: true,
      };
    case 'hovered':
      return {
        ...normal,
        delete: true,
        changeRectangleBgColor: true,
      };
    case 'delete-hovered':
      return {
        ...normal,
        delete: true,
        changeDeleteColor: true,
        changeRectangleBgColor: true,
      };
    case 'error':
      return {
        ...normal,
        icon: undefined,
        error: true,
        pale: true,
        changeRectangleBgColor: true,
      };
    case 'error-hovered':
      return {
        ...normal,
        icon: undefined,
        error: false,
        pale: true,
        delete: true,
        hoveredErrorMessage: true,
        changeRectangleBgColor: true,
      };
    case 'error-delete-hovered':
      return {
        ...normal,
        icon: undefined,
        error: false,
        delete: true,
        changeDeleteColor: true,
        pale: true,
        hoveredErrorMessage: true,
        changeRectangleBgColor: true,
      };
  }
};
